import { gql } from "@apollo/client";

export const GET_IMPRIMIR_MINUTA_DOCUMENTO = gql`
    query GetImprimirMinutaDocumento($minutas: [Int!]!) {
        imprimirMinutaDocumento(minutas: $minutas) {
            success,
            error,
            valorEsperado 
        }
    }
`;